import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DataTableColumnActions } from './data-table-column-actions.config';
import { CommonModule } from '@angular/common';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'data-table-column-actions',
  imports: [CommonModule, NgbTooltipModule],
  templateUrl: './data-table-column-actions.component.html',
  styleUrl: './data-table-column-actions.component.scss'
})
export class DataTableColumnActionsComponent {
  @Input() column!: DataTableColumnActions;
  @Input() item!: any;
  @Output() deleteClicked = new EventEmitter<any>();
  
constructor() {
}

  onButtonClick(button: any) {    
    
    if (button.isDelete) {
      this.deleteClicked.emit(this.item);
    } else {
      button.onClick?.(this.item);
    }
  }
}
